/**
 * Auth-token-attachment mechanism for the headless print routes
 * (`/print/cotizacion/:id`, `/print/informe/:id`).
 *
 * Backend contract (verified against jag-backend/Util/InterceptarSesion.js,
 * the real auth gate for `/cotizacion` and `/order` routes — NOT
 * `Middleware/auth.js`): it accepts the token via `req.query.token` OR the
 * `authentication` header.
 *
 * `Util/Axios.js`'s request interceptor unconditionally reads
 * `localStorage.getItem("token")` on EVERY request to build the
 * `authentication` header, regardless of anything set on axios defaults.
 * So writing the URL token into localStorage under the "token" key is what
 * actually makes the reused data-fetching components (which call the shared
 * `API` client unmodified — CotizacionDocumento, ReportDocument, UserTag,
 * etc.) authenticate correctly, with ZERO changes needed to those
 * components or to Axios.js.
 *
 * This is safe specifically because these print pages are only ever
 * navigated by jag-backend's own Puppeteer instance — a completely
 * isolated browser context that never carries a real user's session state.
 */
export const applyPrintToken = (token) => {
  if (!token) {
    return false;
  }

  window.localStorage.setItem("token", token);
  return true;
};
